// extracted by mini-css-extract-plugin
module.exports = {"container":"NLP_container__1FsMt","title":"NLP_title__3ppZG","sub-title":"NLP_sub-title__3Gedx","services":"NLP_services__Qgobh","details-item":"NLP_details-item__17OJG"};